import React from "react";
import Header from "../../../Header";
import MenuBar from "../../../MenuBar";
import Footer from "../../../Footer";
import "./webhookDetails.css";
import "../../../analytics/analytics.css";
import { Chip, Typography } from "@mui/material";
import { useEffect } from "react";
import { useAuth } from "../../../../context/API_Client";
import { useLocation, useNavigate } from "react-router";
import { useState } from "react";
import {
  convertIsoToGivenTimeZone,
  currentTimeInTimezone,
  parseAsDate,
} from "../../../utils/utils";
import CustomChips from "../../../../reusableComponents/CustomChips";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import SmallModal from "../../../../reusableComponents/modals/SmallModal";
import { customToast } from "../../../../reusableComponents/customToaster/customToast";

const WebhookDetails = () => {
  const {
    getSpecificIdWebhookDetails,
    getAllWebhookDetails,
    postNotificationStatus,
    merchantSettings,
  } = useAuth();

  const location = useLocation();
  const queryParameters = new URLSearchParams(location.search);
  let webhookId = queryParameters.get("webhookId");

  const [url, setUrl] = useState();
  const [description, setDescription] = useState();
  const [active, setActive] = useState(null);
  const [errorRate, setErrorRate] = useState();
  const [creationTime, setCreationTime] = useState();
  const [lastTriggered, setLastTriggerd] = useState();
  const [eventsTable, setEventsTable] = useState();
  const [activeEvents, setActiveEvents] = useState();
  const [toggleNoWeebhookIdErrorDialog, setToggleNoWeebhookIdErrorDialog] =
    useState(false);
  const [
    toggleInvalidWeebhookIdErrorDialog,
    setToggleInvalidWeebhookIdErrorDialog,
  ] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (!webhookId) {
      webhookId = null;
    }
    merchantSettings(
      function (merchantData) {
        getSpecificIdWebhookDetails(
          webhookId,
          function (data) {
            setUrl(data?.url);
            setDescription(data?.description);
            setActive(data?.enabled);
            const addedTime = data?.addedOn;
            setActiveEvents(data?.events?.length);

            postNotificationStatus(
              {
                fromDate: currentTimeInTimezone(
                  data?.addedOn,
                  merchantData?.timeZone
                ),
                toDate: currentTimeInTimezone(
                  new Date().toISOString(),
                  merchantData?.timeZone
                ),
                attributeFilters: {
                  notificationSettingId: webhookId,
                },
              },
              function (data) {
                setCreationTime(
                  convertIsoToGivenTimeZone(addedTime, data?.timeZone)
                );
                const events = [];
                for (let i = 0; i < data?.points?.length; i++) {
                  if (data?.points[i]?.errorRatePercent) {
                    setErrorRate(data?.points[i]?.errorRatePercent);
                  }
                  if (data?.points[i]?.lastTriggeredTimestamp) {
                    setLastTriggerd(data?.points[i]?.lastTriggeredTimestamp);
                  }
                  if (data?.points[i]?.operationNames) {
                    let type = data?.points[i]?.operationNames;

                    switch (type) {
                      case "Authorisation":
                        events.push([
                          "Payment Authorisation",
                          data?.points[i]?.latestStatusCode,
                        ]);
                        break;
                      case "Capture":
                        events.push([
                          "Payment Captured",
                          data?.points[i]?.latestStatusCode,
                        ]);
                        break;
                      case "Partial_Capture":
                        events.push([
                          "Payment Partial Captured",
                          data?.points[i]?.latestStatusCode,
                        ]);
                        break;
                      case "Cancel":
                        events.push([
                          "Payment Canceled",
                          data?.points[i]?.latestStatusCode,
                        ]);
                        break;
                      case "Refund":
                        events.push([
                          "Payment Refunded",
                          data?.points[i]?.latestStatusCode,
                        ]);
                        break;
                      case "Partial_Refund":
                        events.push([
                          "Payment Partial Refunded",
                          data?.points[i]?.latestStatusCode,
                        ]);
                    }
                  }
                }
                setEventsTable(events);
              },
              function (errMsg) {
                customToast("error", "high", errMsg);
              }
            );
          },
          function (errorMsg) {
            if (errorMsg === "noWebhookId") {
              setToggleNoWeebhookIdErrorDialog(true);
            } else if (errorMsg === "invalidWebhookId") {
              setToggleInvalidWeebhookIdErrorDialog(true);
            } else {
              customToast("error", "high", errorMsg);
            }
          }
        );
      },
      function (error) {
        customToast("error", "high", error);
      }
    );
  }, []);

  const handleNoWebhookIdDialog = () => {
    setToggleNoWeebhookIdErrorDialog(false);
    navigate("/developers/webhooks");
  };

  const handleInvalidWebhookIdDialog = () => {
    setToggleInvalidWeebhookIdErrorDialog(false);
    navigate("/developers/webhooks");
  };

  const handleLogsNavigation = () => {
    sessionStorage.setItem("webhooksAndLogsTab", "1");
    navigate("/developers/webhooks?webhookUrl=" + url);
  };

  return (
    <>
      <div className="content-wrapper" style={{ background: "white" }}>
        <section
          className="content"
          style={{
            backgroundColor: "white",
          }}
        >
          <SmallModal
            headerText={"Invalid Webhook Configuration"}
            subHeaderText={
              "Please enter the correct Webhook Id or click on the button below to go back"
            }
            filledBtnText={"Go Back"}
            filledBtnFunction={handleInvalidWebhookIdDialog}
            toggleDialog={toggleInvalidWeebhookIdErrorDialog}
          />
          <SmallModal
            headerText={"Webhook Configuration not found"}
            subHeaderText={
              "Please checK the URL, as the Weebhook Id parameter is missing. Please enter the Weebhook Id parameter in the URL or click on the button below to go back"
            }
            filledBtnText={"Go Back"}
            filledBtnFunction={handleNoWebhookIdDialog}
            toggleDialog={toggleNoWeebhookIdErrorDialog}
          />
          <Typography
            className="headerH3Bold"
            style={{
              width: "100%",
              wordBreak: "break-word",
            }}
          >
            {url}
          </Typography>

          <div className="webhooks-details-root">
            <div className="webhooks-details-container">
              <div className="webhooks-details-summary">
                <div className="webhooks-details-summary-left">
                  {description && (
                    <div className="webhooks-details-summary-left-children">
                      <Typography className="bodyB2Medium font-light-grey">
                        Description:
                      </Typography>
                      <Typography
                        className="subHeaderMedium "
                        style={{ wordWrap: "break-word" }}
                      >
                        {description}
                      </Typography>
                    </div>
                  )}
                  <div className="time-status-error-container">
                    {creationTime && (
                      <div className="webhooks-details-summary-left-children">
                        <Typography className="bodyB2Medium font-light-grey">
                          Created Date & Time:
                        </Typography>
                        <Typography className="subHeaderMedium">
                          {creationTime}
                        </Typography>
                      </div>
                    )}
                    <div className="webhooks-details-summary-left-children">
                      {active != null && (
                        <>
                          <Typography className="bodyB2Medium font-light-grey">
                            Status:
                          </Typography>

                          <CustomChips
                            type={active ? 1 : 0}
                            text={active ? "Active" : "Inactive"}
                          />
                        </>
                      )}
                    </div>
                    {errorRate && (
                      <div className="webhooks-details-summary-left-children">
                        <Typography className="bodyB2Medium font-light-grey">
                          Error rate:
                        </Typography>
                        <Typography
                          className="subHeaderMedium"
                          sx={{ color: "rgba(188, 28, 28, 1) !important" }}
                        >
                          {`${errorRate}%`}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>
                <div className="webhooks-details-summary-right">
                  <Typography className="bodyB2Medium font-light-grey">
                    Configuration:
                  </Typography>

                  <Typography
                    className="subHeaderMedium font-link"
                    onClick={handleLogsNavigation}
                  >
                    View event logs
                  </Typography>
                </div>
              </div>
              <div className="webhooks-detailed-report-root">
                <Typography className="subHeaderSemiBold">
                  Detailed Report:
                </Typography>
                <div className="webhooks-detailed-report">
                  {activeEvents && (
                    <div className="webhooks-detailed-report-g">
                      <Typography className="bodyB2Medium font-light-grey">
                        Active events:
                      </Typography>
                      <div>
                        <div className="active-elements">
                          <Typography className="labelMedium">
                            {activeEvents}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  )}
                  {lastTriggered && (
                    <div className="webhooks-detailed-report-g">
                      <Typography className="bodyB2Medium font-light-grey">
                        Last Triggered:
                      </Typography>
                      <Typography className="subHeaderMedium">
                        {lastTriggered}
                      </Typography>
                    </div>
                  )}
                </div>
                {eventsTable?.length > 0 && (
                  <div className="event-notification-table">
                    <div className="event-notification-table-row">
                      <div
                        className="event-notification-table-cell"
                        style={{
                          background: "rgba(253, 253, 253, 1)",
                        }}
                      >
                        <Typography className="bodyB2Medium">Events</Typography>
                      </div>
                      <div
                        className="event-notification-table-cell"
                        style={{ justifyContent: "center" }}
                      >
                        <Typography className="bodyB2Medium">
                          Notification Status
                        </Typography>
                      </div>
                    </div>
                    {eventsTable?.map((row, i) => (
                      <div
                        className="event-notification-table-row"
                        style={{
                          background:
                            i % 2 !== 0 ? "rgba(253, 253, 253, 1)" : "none",
                          borderRadius: "16px",
                        }}
                      >
                        {row?.map((col, j) => (
                          <div
                            className="event-notification-table-cell"
                            style={{
                              justifyContent: j === 1 ? "center" : "flex-start",
                            }}
                          >
                            {j === 1 ? (
                              <CustomChips
                                type={col == "200" ? 1 : 0}
                                text={col}
                              />
                            ) : (
                              <Typography className="bodyB2RegularText">
                                {col}
                              </Typography>
                            )}
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="webhooks-details-description-table"></div>
              <div className="webhooks-details-disclaimer">
                <Typography className="bodyB2Medium font-light-grey">
                  Disclaimer:
                </Typography>
                <Typography className="labelRegular">
                  Please be advised that we periodically conduct internal
                  testing of webhook events to ensure system reliability. Rest
                  assured, these tests are non-intrusive and designed to
                  maintain the seamless operation of your webhook
                  configurations.
                </Typography>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default WebhookDetails;
